import { getCookie, decryptAes } from '../../../utils';
import { productSystemEnum } from '../../../constants/product-system';
import { amendmentResourcesEnum } from '../../../constants/amendment-resources';

export default () => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  const productId = decipher?.client?.productId;
  const isVereadorOuPrefeito = productId === productSystemEnum.VEREADOR || productId === productSystemEnum.PREFEITO;

  return {
    id: null,
    stageId: null,
    secretaryId: null,
    value: null,
    object: null,
    observation: null,
    paymentDate: null,
    year: new Date().getFullYear().toString(),

    resourceOrigin: isVereadorOuPrefeito
      ? amendmentResourcesEnum.SOLICITACAO_PARA_DEPUTADO
      : null,

    requester: [],
    beneficiary: [],

    region: [],
    regionOptions: [],

    isEditing: false,
    isCopy: false,
  }
};
